import React from 'react'
import {Input} from 'antd'

const SingleInput = () => <Input size="large"></Input>
export default SingleInput
